angular.module('impactx.search').controller('SearchFilterCtrl', [
    '$scope',
    'SearchService',
    'SearchFilter',
    '$locale',
    'AppConfiguration',
    'TranslationService',
    '$filter',
    SearchFilterController
]);

function SearchFilterController($scope, SearchService, SearchFilter, $locale, AppConfiguration, TranslationService, $filter) {
    $scope.enterDateLabel = TranslationService.get("enterDate");
    var self = this;
    self.isOpen = function () {
        return SearchFilter.isOpen();
    };
    self.numberOfAttributes = 3;
    self.minPriceFormatted = '';
    self.maxPriceFormatted = '';
    self.showAllProductLabelsMap = new Map();
    self.showAllEnergyLabelsMap = new Map();
    self.wasProductFamilySelected = false;
    self.$onInit = function () {
        SearchFilter.closeSidebar();
        self.filters = SearchFilter.getFilters();

        var selectedGuidingClassification = {id: 0};
        if (impactX.isDefined(self, 'filters.guidingClassification.selected.id')) {
            selectedGuidingClassification = self.filters.guidingClassification.selected;
        }
        getClassificationFilter(selectedGuidingClassification);
        initializeConfig();
        updateFilterCount();
    };

    $scope.$watch(function () {
        return self.needsReset && self.needsReset.value
    }, function (newVal) {
        if (newVal) {
            self.needsReset.value = false;
            if (!SearchFilter.isOpen()) {
                SearchFilter.closeSidebar();
            }
            self.filters = SearchFilter.getFilters();

            var selectedGuidingClassification = {id: 0};
            if (impactX.isDefined(self, 'filters.guidingClassification.selected.id')) {
                selectedGuidingClassification = self.filters.guidingClassification.selected;
            }
            getClassificationFilter(selectedGuidingClassification);
            initializeConfig();
            updateFilterCount();
        }
    });

    self.$onDestroy = function () {
        SearchService.setUserSearchConfigParameter('showFacets', self.config.showFacets);
        SearchService.setUserSearchConfigParameter('showGeneralFilters', self.config.showGeneralFilters);
        SearchService.setUserSearchConfigParameter('showCategoryFilters', self.config.showCategoryFilters);
    };

    self.onSupplierChange = function (selected) {
        if (selected) {
            SearchFilter.setSupplier(selected);
        }
        else {
            SearchFilter.setSupplier(null);
            self.filters.supplier.selected = null;
        }
        self.search();
    };

    self.nextEClassLevel = function (selectedNode) {
        SearchFilter.nextEClassLevel(selectedNode).then(function (guidingClassification) {
            var currentSelection = self.filters.guidingClassification.selected;
            self.filters.guidingClassification = guidingClassification;
            self.filters.guidingClassification.selected = currentSelection;
            angular.element("#search-filter").find('.nano').nanoScroller({scrollTo: angular.element("#guidingClassificationAnchor")});
        });
    };

    self.onEClassItemChange = function (selected) {
        self.filters.guidingClassification.selected = selected;
        self.search();
    };

    self.onProductFamilyChange = function () {
        var procurementGroupSelected = impactX.isDefined(self, "filters.procurementGroup.selected");
        if (procurementGroupSelected &&  self.wasProductFamilySelected) {
            self.filters.procurementGroup.selected = null;
        }
        self.wasProductFamilySelected = !!impactX.isDefined(self, "filters.productFamily.selected");
        self.search();
    };

    self.onProcurementGroupChange = function () {
        self.search();
    };

    self.onManufacturerChange = function (remove) {
        if (remove) {
            self.filters.manufacturer.value = null;
        }
        SearchFilter.setManufacturer(self.filters.manufacturer.value);
        self.search();
    };

    self.onContractNoChange = function (remove) {
        if (remove) {
            self.filters.contractNo.value = null;
        }
        SearchFilter.setContractNo(self.filters.contractNo.value);
        self.search();
    };

    self.onSupplierNoChange = function (remove) {
        if (remove) {
            self.filters.supplierNo.value = null;
        }
        SearchFilter.setSupplierNo(self.filters.supplierNo.value);
        self.search();
    };

    self.onManufacturerNoChange = function (remove) {
        if (remove) {
            self.filters.manufacturerNo.value = null;
        }
        SearchFilter.setManufacturerNo(self.filters.manufacturerNo.value);
        self.search();
    };

    self.onEanChange = function (remove) {
        if (remove) {
            self.filters.ean.value = null;
        }
        SearchFilter.setEan(self.filters.ean.value);
        self.search();
    };

    self.onListFilterChange = function (field, remove) {
        if (remove) {
            self.filters.listFilters[field].value = null;
        }
        SearchFilter.setListFilterField(field, self.filters.listFilters[field].value);
        self.search();
    };

    self.onCompanySizeSelected = function (selected) {
        self.setListFilterPopupField("companySize", selected);
        self.search();
    };

    self.onCountrySelected = function (selected) {
        self.setListFilterPopupField("country", selected);
        self.search();
    };

    self.onStartDateSelect = function () {
        SearchFilter.setListFilterDateField("startDate", self.filters.listFilters.startDate);
        self.search();
    };

    self.onEndDateSelect = function () {
        SearchFilter.setListFilterDateField("endDate", self.filters.listFilters.endDate);
        self.search();
    };
    
    self.onIsNaBeChange = function () {
        SearchFilter.setListFilterField("isNaBe", self.filters.listFilters.isNaBe.value);
        self.search();
    };

    self.setListFilterPopupField = function (field, selected) {
        SearchFilter.setListFilterPopupField(field, selected);
        self.search();
    };

    self.onCategoryChange = function (category) {
        if (category) {
            category.value = false;
        }
        self.search();
    };

    self.onMinPriceChange = function (remove) {
        if (remove) {
            self.filters.priceRange.minValue.value = 0;
        }

        // Prüfe ob der Wert ungültig ist (nur "-" eingegeben)
        // und verhindere in dem Fall den Request
        var value = self.filters.priceRange.minValue.value;
        if (value === undefined || isNaN(value)) {
            return;
        }

        SearchFilter.setMinPrice(self.filters.priceRange.minValue);
        self.minPriceFormatted = self.formatMoney(self.filters.priceRange.minValue);
        self.search();
    };

    self.onMaxPriceChange = function (remove) {
        if (remove) {
            self.filters.priceRange.maxValue.value = 0;
        }

        // Prüfe ob der Wert ungültig ist (nur "-" eingegeben)
        // und verhindere in dem Fall den Request
        var value = self.filters.priceRange.maxValue.value;
        if (value === undefined || isNaN(value) ) {
            return;
        }

        SearchFilter.setMaxPrice(self.filters.priceRange.maxValue);
        self.maxPriceFormatted = self.formatMoney(self.filters.priceRange.maxValue);
        self.search();
    };

    self.onProductLabelChange = function (productLabel) {
        productLabel.value = !productLabel.value;
        self.search();
    };

    self.onEnergyLabelChange = function (energyLabel) {
        energyLabel.value = !energyLabel.value;
        self.search();
    };

    self.onCountryChange = function () {
        self.search();
    };

    self.onSearchInputChange = function () {
        self.search();
    }

    self.selectAll = function (entries) {
        if (entries) {
            angular.forEach(entries, function(entry) {
                entry.value = true;
            });
            self.search();
        }
    };

    self.unselectAll = function (entries) {
        if (entries) {
            angular.forEach(entries, function(entry) {
                entry.value = false;
            });
            self.search();
        }
    };

    self.isSelectAll = function (entries) {
        if (entries) {
            var isSelectAll = true;
            angular.forEach(entries, function(entry) {
                if (isSelectAll && !entry.value)
                {
                    isSelectAll = false;
                }
            });
            return isSelectAll;
        } else {
            return false;
        }
    };

    self.toggleAttributes = function () {
        if (self.numberOfAttributes < 0) {
            self.numberOfAttributes = 3;
        }
        else {
            self.numberOfAttributes = -1;
        }
    };

    self.search = function () {
        self.onFilterChange().then(function () {
            getClassificationFilter();
            updateFilterCount();
            // Notify Angular components that filter has changed
            SearchFilter.notifyFilterChanged();
        });
    };

    self.toggleFacets = function () {
        self.config.showFacets = !self.config.showFacets;
    };

    self.showAllProductLabels = function (groupId) {
        return self.showAllProductLabelsMap.has(groupId) && self.showAllProductLabelsMap.get(groupId);
    };

    self.toggleShowAllProductLabels = function (groupId) {
        self.showAllProductLabelsMap.set(groupId, !self.showAllProductLabels(groupId));
    };

    self.showAllEnergyLabels = function (groupId) {
        return self.showAllEnergyLabelsMap.has(groupId) && self.showAllEnergyLabelsMap.get(groupId);
    };

    self.toggleShowAllEnergyLabels = function (groupId) {
        self.showAllEnergyLabelsMap.set(groupId, !self.showAllEnergyLabels(groupId));
    };

    self.toggleGeneralFilters = function () {
        self.config.showGeneralFilters = !self.config.showGeneralFilters;
    };

    self.toggleCategoryFilters = function () {
        self.config.showCategoryFilters = !self.config.showCategoryFilters;
    };

    self.removeDrillDown = function (facet) {
        var indexToRemove = -1;
        var drillDowns = self.filters.drillDowns;
        angular.forEach(drillDowns, function (value, key) {
            if (value.pathHashString == facet.pathHashString) {
                indexToRemove = key;
            }

        });
        if (indexToRemove >= 0) {
            drillDowns.splice(indexToRemove, 1)
        }

        self.search();
    };

    var getFacet = function (drillDown) {
        var facets = self.filters.facets;
        if (facets.length > 0) {
            var result = {};
            angular.forEach(facets, function (facet) {
                var match = facet.displayOptions.filter(function (item) {
                    return item.pathHashString === drillDown.pathHashString;
                })[0];
                if (match) {
                    result = facet;
                    return;
                }
            });

            return result;
        }
    };

    self.getDrillDownLabel = function (drillDown) {
        var value = getFacet(drillDown);
        if (value) {
            return value.label;
        }
    };

    var checkFilter = function (filter) {
        return !!(filter && (filter.value || filter.selected))
    };

    var checkGuidingClassification = function () {
        return !!impactX.isDefined(self, 'filters.guidingClassification.selected.id');
    };

    self.anyFiltersSet = function () {
        return (self.filters.drillDowns && self.filters.drillDowns.length > 0)
            || checkGuidingClassification()
            || checkFilter(self.filters.searchInput)
            || checkFilter(self.filters.supplier)
            || checkFilter(self.filters.manufacturer)
            || checkFilter(self.filters.contractNo)
            || checkFilter(self.filters.supplierNo)
            || checkFilter(self.filters.ean)
            || checkFilter(self.filters.productFamily)
            || checkFilter(self.filters.procurementGroup)
            || checkFilter(self.filters.country)
            || !!self.filters.priceRange &&
            (checkFilter(self.filters.priceRange.minValue)
                || checkFilter(self.filters.priceRange.maxValue));
    };

    self.resetFilters = function () {
        while (self.filters.drillDowns.length > 0) {
            var item = self.filters.drillDowns[0];
            self.removeDrillDown(item);
        }
        self.filters.guidingClassification.selected = {id: 0};
        self.filters.procurementGroup.selected = null;
        self.filters.productFamily.selected = null;
        if (self.filters.country) {
            self.filters.country.selected = null;
        }

        self.filters.supplier.selected = null;
        self.filters.manufacturer.value = null;
        self.filters.contractNo.value = null;
        self.filters.supplierNo.value = null;
        self.filters.ean.value = null;
        self.filters.priceRange.minValue.value = 0;
        self.filters.priceRange.maxValue.value = 0;

        SearchFilter.setSupplier(self.filters.supplier.selected);
        SearchFilter.setManufacturer(self.filters.manufacturer.value);
        SearchFilter.setContractNo(self.filters.contractNo.value);
        SearchFilter.setSupplierNo(self.filters.supplierNo.value);
        SearchFilter.setMinPrice(self.filters.priceRange.minValue);
        SearchFilter.setMaxPrice(self.filters.priceRange.maxValue);
        SearchFilter.setEan(self.filters.ean.value);

        self.search();
    };

    function initializeConfig() {
        self.config = SearchFilter.getConfig();

        self.config.showFacets = SearchService.userSearchConfig('showFacets');
        self.config.showGeneralFilters = SearchService.userSearchConfig('showGeneralFilters');
        self.config.showCategoryFilters = SearchService.userSearchConfig('showCategoryFilters') || !!self.filters.guidingClassification.selected;
        self.config.showProductFamilyFilter = SearchService.userSearchConfig('showProductFamilyFilter');
        self.config.showProcurementGroupFilter = SearchService.userSearchConfig('showProcurementGroupFilter');
        self.config.showGuidingClassificationFilter = SearchService.userSearchConfig('showGuidingClassificationFilter');
    }

    function getClassificationFilter(selected) {
        var selectedEntry;
        if (selected) {
            selectedEntry = selected;
        }
        else {
            selectedEntry = impactX.isDefined(self, 'filters.guidingClassification.selected')
        }
        return SearchFilter.nextEClassLevel(selectedEntry).then(function (guidingClassification) {
            self.filters.guidingClassification = guidingClassification;
            self.filters.guidingClassification.selected = selectedEntry;
            var superEntry = guidingClassification.superEntries[guidingClassification.superEntries.length - 1];
            SearchFilter.setSearchInputClassification(superEntry);
        });
    }

    self.formatMoney = function (filter) {
        var value = filter.value;
        if (value) {
            var currency = self.filters.priceRange.currency;
            var formats = $locale.NUMBER_FORMATS;
            var maxFrac = 11 - Math.floor(Math.log(value) / Math.log(10));
            var number = Math.round(value * Math.pow(10, maxFrac + 2)) / Math.pow(10, maxFrac + 4);
            var pattern =
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": maxFrac,
                    "minFrac": 2,
                    "negPre": "-",
                    "negSuf": " " + currency,
                    "posPre": "",
                    "posSuf": " " + currency
                };
            return formatNumber(number, pattern, formats.GROUP_SEP, formats.DECIMAL_SEP);
        }
    };

    self.clearSelection = function (property) {
        property.selected = undefined;
        self.search();
    };

    self.clearProductFamily = function (property) {
        property.selected = undefined;
        self.clearSelection(self.filters.procurementGroup)
    };

    function updateFilterCount() {
        var selectedFilterAmount = 0;
        var selectedFilterEntries = [];
        var filters = self.filters;
        if (filters) {
            if (!self.useListFilters) {
                if (impactX.isDefined(filters, 'productFamily.selected.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.productFamily.label,
                        value: filters.productFamily.selected.value
                    });
                }
                if (impactX.isDefined(filters, 'procurementGroup.selected.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.procurementGroup.label,
                        value: filters.procurementGroup.selected.value
                    });

                }
                if (impactX.isDefined(filters, 'guidingClassification.selected.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.guidingClassification.label,
                        value: filters.guidingClassification.selected.value
                    });
                }
                if (impactX.isDefined(filters, 'supplier.selected.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({name: filters.supplier.label, value: filters.supplier.selected.value});
                }
                if (impactX.isDefined(filters, 'manufacturer.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.manufacturer.label,
                        value: filters.manufacturer.value
                    });
                }
                if (impactX.isDefined(filters, 'contractNo.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({name: filters.contractNo.label, value: filters.contractNo.value});
                }
                if (impactX.isDefined(filters, 'supplierNo.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({name: filters.supplierNo.label, value: filters.supplierNo.value});
                }
                if (self.minPriceFormatted) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.priceRange.minValue.label,
                        value: self.minPriceFormatted
                    });
                }
                if (self.maxPriceFormatted) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.priceRange.maxValue.label,
                        value: self.maxPriceFormatted
                    });
                }
                angular.forEach(filters.productLabelGroups, function (group) {
                    angular.forEach(group.labels, function (label) {
                        if (label.value) {
                            selectedFilterAmount++;
                            selectedFilterEntries.push({name: group.name, value: label.name});
                        }
                    });
                });
                angular.forEach(filters.energyLabelGroups, function (group) {
                    angular.forEach(group.labels, function (label) {
                        if (label.value) {
                            selectedFilterAmount++;
                            selectedFilterEntries.push({name: group.name, value: label.name});
                        }
                    });
                });
                angular.forEach(filters.category.entries, function (category) {
                    if (category.value) {
                        selectedFilterAmount++;
                        selectedFilterEntries.push({name: filters.category.groupTitle, value: category.label});
                    }
                });
                if (impactX.isDefined(filters, 'country.selected.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.country.label,
                        value: filters.country.selected.value
                    });

                }
                angular.forEach(filters.drillDowns, function (drillDown) {
                    var drillDownLabel = self.getDrillDownLabel(drillDown);
                    if (drillDownLabel) {
                        selectedFilterAmount++;
                        selectedFilterEntries.push({name: self.getDrillDownLabel(drillDown), value: drillDown.label});
                    }
                });
                if (self.showSearchFilter &&
                    impactX.isDefined(filters, 'searchInput.value')) {
                    var searchInput = filters.searchInput;
                    selectedFilterAmount++;
                    selectedFilterEntries.push({name: searchInput.label, value: searchInput.value});
                }
            }
            else {
                if (impactX.isDefined(filters, 'listFilters.name.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.name.label,
                        value: filters.listFilters.name.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.gzPosition.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.gzPosition.label,
                        value: filters.listFilters.gzPosition.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.treatmentType.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.treatmentType.label,
                        value: filters.listFilters.treatmentType.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.zip.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.zip.label,
                        value: filters.listFilters.zip.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.city.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.city.label,
                        value: filters.listFilters.city.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.supplierName.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.supplierName.label,
                        value: filters.listFilters.supplierName.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.companyName.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.companyName.label,
                        value: filters.listFilters.companyName.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.productFamily.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.productFamily.label,
                        value: filters.listFilters.productFamily.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.country.selected.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.country.label,
                        value: filters.listFilters.country.selected.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.companySize.selected.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.companySize.label,
                        value: filters.listFilters.companySize.selected.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.startDate.dateValue')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.startDate.label,
                        value: $filter('date')(filters.listFilters.startDate.dateValue, 'mediumDate')
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.endDate.dateValue')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.endDate.label,
                        value: $filter('date')(filters.listFilters.endDate.dateValue, 'mediumDate')
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.taxid.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.taxid.label,
                        value: filters.listFilters.taxid.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.vendorId.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.vendorId.label,
                        value: filters.listFilters.vendorId.value
                    });
                }
                if (impactX.isDefined(filters, 'listFilters.isNaBe.value')) {
                    selectedFilterAmount++;
                    selectedFilterEntries.push({
                        name: filters.listFilters.isNaBe.label,
                        value: filters.listFilters.isNaBe.value
                    });
                }
             }
        }

        SearchFilter.selectedFilter.amount = selectedFilterAmount;
        SearchFilter.selectedFilter.entries = selectedFilterEntries;
    }

    $scope.onScroll = function (event, scrollTop) {
        var element = angular.element('ix-search-filter');
        if (scrollTop > 0) {
            element.css("z-index", 1);
        }
        else {
            element.css('z-index', "");
        }
    };
}
